import type { FC } from 'react';
import type { SpecificationsEntity } from '../../../../../@types/gql/product-detail';

const ProductDetailSpecifications: FC<{
  description: string;
  list: SpecificationsEntity[];
}> = ({ description, list }) => {
  return (
    <div>
      <p className="font-light tracking-wide text-justify whitespace-pre-wrap">
        {description}
      </p>

      <div className="overflow-x-auto mt-10">
        <table className="w-full min-w-[700px]">
          <thead>
            <tr className="divide-x border divide-[#BDBDBD] bg-[#F4F4F4] border-[#BDBDBD]">
              {list.map(({ TableHeading, id }) => {
                return (
                  <th
                    className="px-5 py-4 font-bold uppercase text-[#121212] text-left max-md:text-base"
                    key={id}
                  >
                    {TableHeading}
                  </th>
                );
              })}
            </tr>
          </thead>

          {/*<tbody>
            <tr>
              <td className="py-2" colSpan={list.length} />
            </tr>
          </tbody>*/}
          <tbody className="border border-[#BDBDBD]">
            {list.length > 0 && list[0].TableData
              ? list[0].TableData.map((_, index) => (
                  <tr
                    className="divide-x border-b border-[#BDBDBD] divide-[#BDBDBD]"
                    key={`data-${index.toString()}`}
                  >
                    {list.map((spec) => (
                      <td
                        className="px-5 py-4 text-base text-[#121212] text-left font-medium max-md:text-base"
                        key={spec.id}
                      >
                        {spec.TableData?.[index]?.Name==='&nbsp'? '':spec.TableData?.[index]?.Name}
                      </td>
                    ))}
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductDetailSpecifications;
